import React, { useState } from 'react';
import { Button, DatePicker, Modal, notification, Space, Spin } from 'antd';
import { useMutation, useQueryClient } from 'react-query';

import { handleAPIError } from '@services/base';
import useModal, { IModalPayload } from '@hooks/use-modal';

import { IInvoice } from '@services/invoice/invoice.model';
import { accountInvoices } from '@services/invoice';
import { Landmark } from 'lucide-react';

const AccountInvoiceModal = () => {
  const [modal, setModal] = useModal<IModalPayload<any>>('invoice-account');
  const [data, setData] = useState<IInvoice[]>([]);
  const [date, setDate] = useState<any>(new Date());
  const onClose = () => {
    setModal({ isOpen: false, payload: null });
    setData([]);
  };

  const handleDateChange = (date: any) => {
    setDate(date);
  };

  const queryClient = useQueryClient();

  const { isLoading: isSubmitting, mutate } = useMutation(
    (payload: { ids: string[]; date: Date }) => {
      return accountInvoices(payload.ids, {
        status: 'ACCOUNTED',
        accounted_at: payload.date,
      });
    },
    {
      onSuccess: async res => {
        onClose();
        await queryClient.invalidateQueries('invoices');
        if (!res.error) {
          notification.success({
            message: 'Success',
            description: 'Invoice accounted successfully',
          });
        } else {
          notification.error({
            message: 'Error',
            description: 'Cannot account invoice',
          });
        }
      },
      onError: handleAPIError,
    },
  );

  const submit = () => {
    const payload = {
      ids: modal?.payload.ids,
      date,
    };
    mutate(payload);
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={720}
      onCancel={onClose}
      footer={null}
      title={
        <>
          <Landmark size={14} className={'mr-2'} />
          Account invoice
          {data?.length ? <span className="ml-1">({data.length})</span> : null}
        </>
      }
      visible={modal?.isOpen || false}
    >
      <Spin spinning={isSubmitting}>
        <div
          style={{
            maxHeight: '280px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label>Select accounted date</label>
          <DatePicker
            showTime={{
              format: 'HH:mm',
            }}
            onChange={handleDateChange}
            format="YYYY-MM-DD HH:mm"
          />
        </div>
        <br />
        <div className={'text-center'}>
          <Space align={'center'}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              onClick={submit}
              type="primary"
              icon={
                <Landmark
                  size={14}
                  style={{
                    marginRight: '5px',
                  }}
                />
              }
            >
              Confirm
            </Button>
          </Space>
        </div>
      </Spin>
    </Modal>
  );
};

export default AccountInvoiceModal;
